/** Runtime config loaded from /config.json (SPA_RUNTIME_CONFIG). */

export interface AuthConfig {
  apiEndpoint: string;
  cognitoAuthDomain: string;
  cognitoClientId: string;
  cognitoUserPoolId: string;
  productId: string;
  userGroupName: string;
  powerUserGroupName: string;
  adminGroupName: string;
  /**
   * B2B Gateway API endpoint used for Google Drive OAuth token exchange
   * and credential storage (GATEWAY-SPEC-011). Required for GDrive features.
   * Routed through the gateway because it manages OAuth providers and
   * per-user credential storage via the App Credentials API.
   */
  b2bGatewayApiEndpoint: string;
}

let cached: AuthConfig | null = null;

export async function loadAuthConfig(): Promise<AuthConfig> {
  if (cached) return cached;
  try {
    const res = await fetch("/config.json");
    if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
    cached = (await res.json()) as AuthConfig;
    if (!cached.b2bGatewayApiEndpoint) {
      console.warn(
        "b2bGatewayApiEndpoint is not configured in config.json — Google Drive features will not work"
      );
    }
    return cached;
  } catch (err) {
    console.error("Could not load /config.json:", err);
    // Fallback for local dev
    cached = {
      apiEndpoint: "http://localhost:3000",
      cognitoAuthDomain: "",
      cognitoClientId: "",
      cognitoUserPoolId: "",
      productId: "selerity-reporting",
      userGroupName: "selerity-reporting-user",
      powerUserGroupName: "selerity-reporting-power-user",
      adminGroupName: "selerity-reporting-admin",
      b2bGatewayApiEndpoint: "",
    };
    return cached;
  }
}

export function getConfig(): AuthConfig | null {
  return cached;
}
